'use strict';
const angular = require('angular');
const {element} = angular;

module.exports = [
  GallerySizeDirective];

function GallerySizeDirective() {
  return {
    restrict: 'A',
    scope: {
      use: '=',
      min: '@',
      max: '@',
      margin: '@',
      spacing: '@'
    },
    controllerAs: 'gallerySize',
    bindToController: true,
    controller: ['$scope', '$element', '$window', GallerySizeController]
  };
}

function GallerySizeController($scope, $element, $window) {
  var requestAnimationFrame = $window.requestAnimationFrame;
  var cancelAnimationFrame = $window.cancelAnimationFrame;
  var currentRequest;
  var w = element($window);
  var vm = this;
  var singleColumCutoff = 375;
  vm.onResize = onResize;

  w.bind('resize', vm.onResize);
  _throttledCallback();

  $scope.$on('$destroy', function () {
    w.unbind('resize', vm.onResize);
  });

  function onResize() {
    if (requestAnimationFrame) {
      if (currentRequest && cancelAnimationFrame) cancelAnimationFrame(currentRequest);
      currentRequest = requestAnimationFrame($scope.$safeApplyFunction(_throttledCallback));
    } else {
      if (currentRequest) clearTimeout(currentRequest);
      currentRequest = setTimeout($scope.$safeApplyFunction(_throttledCallback), 33);
    }
  }

  function _throttledCallback() {
    vm.use = _calculateWidth();
    //console.log(' - tile width: ' + vm.use);
    currentRequest = null;
  }

  function _calculateWidth() {
    var min, max, margin, spacing;

    try {
      min = parseFloat(vm.min);
      max = parseFloat(vm.max);
      margin = parseFloat(vm.margin);
      spacing = parseFloat(vm.spacing);
    } catch (e) {
      console.warn('gallery-size expected min, max, margin, & spacing to be valid numbers', $element);
    }

    var availableWidth = $element[0].clientWidth - 2 * margin;
    var maxFit, minFit, remainder, count;

    if (availableWidth <= max) { // consider including the spacing in this calculation for medium phone screens?
      return availableWidth;
    } else if (availableWidth <= singleColumCutoff) {
      return Math.min(max, availableWidth);
    } else {
      maxFit = (availableWidth + spacing) / (max + spacing);
      count = Math.floor(maxFit);  // get the number of tiles that can fit at their max size
      minFit = count + 1; // determine if there is enough space to hold one more currently
      remainder = maxFit - count;

      //console.log(' - remainder: ' + remainder);

      if (remainder < 0.01 || ((minFit * min + (minFit - 1) * spacing) > availableWidth)) {
        //console.log(' - display: ' + count + '. total width: ' + (count * max + (count - 1) * spacing + 2 * margin));
        return max;
      } else { // calculate the width to fit 1 more tile with fixed margin and spacing
        count++;
        //console.log(' - display: ' + count);
        return Math.floor((availableWidth - (count - 1) * spacing) / count);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/gallery-utilities/GallerySizeDirective.js